import { PageRef } from 'providers/page-ref';
import { UiDisplayNutrient } from 'models/display-nutrient';

export type NutritionInfoPageParams = {
  // Complex objects stored in sessionStorage, not URL
  local?: {
    nutrients: UiDisplayNutrient[];
  };
};

export const INutritionInfoPage: PageRef<NutritionInfoPageParams, void> = {
  pageName: 'NutritionInfoPage',
} as PageRef<NutritionInfoPageParams, void>;
